module.exports = __webpack_public_path__ + "static/img/IA-2210.ab2f806.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/listings/custom/IA-2210.jpg
// module id = ubuB
// module chunks = 0